import { render } from "./TheMobile.vue?vue&type=template&id=0aca5e17"
import script from "./TheMobile.vue?vue&type=script&lang=js"
export * from "./TheMobile.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__